module.exports = __webpack_public_path__ + "img/jobs.f01e7c80.svg";